<template>
  <SingleLensDetails v-if="select" :select="select" />
  <div v-else class="loader-div">
    <div class="loader"></div>
  </div>
</template>

<script setup>
import SingleLensDetails from '@/components/SingleLensDetails.vue'
import client from '@/api/client'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import config from '@/config'
import { normalizeSingleLensData } from '@/includes/helper'

const route = useRoute()
const router = useRouter()

const select = ref(null)

const fetchSelectDetails = async () => {
  try {
    const response = await client.get(`${config.apiBaseUrl}/wishlist/id/${route.params.id}`)

    if (response.status !== 200) {
      return router.push('/')
    }

    // normalizeSingleLensData formats the response data into desired structure
    select.value = normalizeSingleLensData(response.data)
  } catch (err) {
    console.log(err)
    return router.push('/')
  }
}

onMounted(async () => {
  await fetchSelectDetails()
})
</script>
